import React, { useEffect, useState } from "react";
import { Form, Spin, Modal, Select, Popconfirm, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";

import "./Questions.scss";
import { PAGE_SIZE } from "../../constants";
import {
	fetchQuestion,
	fetchQuestions,
	updateQuestion,
	deleteQuestion,
} from "../../actions/question";
import QuestionsTable from "../Tables/Questions";
import QuestionForm from "../Forms/Question";
import { fetchCategories } from "../../actions/category";

const QuestionsPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [questionId, setQuestionId] = useState(null);
	const { questions, status, loading } = useSelector(
		(state) => state.fetchQuestions,
	);
	const { categories } = useSelector((state) => state.fetchCategories);
	const { status: updateStatus } = useSelector((state) => state.updateQuestion);
	const { questionDeleted } = useSelector((state) => state.deleteQuestion);
	const [pagination, setPagination] = useState({});
	const [currentPage, setCurrentPage] = useState(1);
	const limit = Number(PAGE_SIZE) || 20;

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Button
					type="link"
					className="btn-table-action-primary"
					onClick={() => handleEdit(record)}
				>
					Edit
				</Button>
				<Popconfirm
					title="Are you sure to delete this one?"
					onConfirm={() => handleDelete(record)}
					okText="Yes"
					cancelText="No"
				>
					<Button type="link" className="btn-table-action-danger">
						Delete
					</Button>
				</Popconfirm>
			</span>
		);
	};

	const handleEdit = (record) => {
		showModal();
		setQuestionId(record.id);
		dispatch(fetchQuestion(record.id));
	};

	const handleDelete = (record) => {
		dispatch(deleteQuestion(record.id));
	};

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleSubmitForm = (values) => {
		const newValues = { ...values };
		if (newValues.require === undefined) {
			newValues.require = false;
		}

		if (questionId) {
			dispatch(updateQuestion(questionId, newValues));
		}
		handleOk();
	};

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(fetchQuestions({ start: Number(startAt), count: PAGE_SIZE }));
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	useEffect(() => {
		dispatch(fetchQuestions({ start: 0, count: PAGE_SIZE }));
		dispatch(fetchCategories({}));
	}, []);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED")
			dispatch(fetchQuestions({ start: 0, count: PAGE_SIZE }));
	}, [updateStatus]);

	useEffect(() => {
		if (questionDeleted) {
			dispatch(fetchQuestions({ start: 0, count: PAGE_SIZE }));
		}
	}, [questionDeleted]);

	useEffect(() => {
		if (questions) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: questions.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [questions]);

	const handleFilterChange = (value) => {
		if (value && value !== "") {
			dispatch(
				fetchQuestions({
					start: 0,
					count: 1000,
					survey_category_id: Number(value),
				}),
			);
		} else {
			dispatch(fetchQuestions({ start: 0, count: PAGE_SIZE }));
		}
	};
	return (
		<Spin spinning={loading} tip="Loading ...">
			<div className="questions-container">
				<div className="page-header">
					<div className="page-header-breadbrumb">
						<ul>
							<li>Questions</li>
						</ul>
					</div>
				</div>
				<div className="page-filter">
					<Select
						showSearch
						allowClear
						placeholder="Select Survey Category"
						optionFilterProp="children"
						filterOption={(input, option) =>
							option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
						onChange={handleFilterChange}
					>
						{categories &&
							categories.data.data.map((category) => (
								<Select.Option key={category.id}>{category.name}</Select.Option>
							))}
					</Select>
				</div>
				<div className="page-content">
					{status === "SUCCEEDED" && (
						<QuestionsTable
							rowKey="id"
							pagination={pagination}
							onChange2={handleTableChange}
							dataSource={questions.data}
							scrollHeight="calc(100vh - 275px)"
							withAction={withAction}
							actionWidth={150}
						/>
					)}
				</div>
				<Modal
					className="topic-modal"
					visible={isModalVisible}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
				>
					<QuestionForm
						form={form}
						questionId={questionId}
						handleSubmitForm={handleSubmitForm}
						handleCancel={handleCancel}
					/>
				</Modal>
			</div>
		</Spin>
	);
};

export default QuestionsPage;
